import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Apps, ProjectLists } from "../../../../Constants/Constants";
import ProjectListHead from "./ProjectListHead";
import ProjectListTabContent from "./ProjectListTabContent";
import { Fragment } from "react/jsx-runtime";

const ProjectListContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ProjectLists} parent={Apps} />
      <Container fluid>
        <Row className="project-cards">
          <Col md="12" className="project-list">
            <ProjectListHead />
          </Col>
          <Col sm="12">
            <ProjectListTabContent />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ProjectListContainer;
